import Icon from "../components/Icon";

export const getFormatedData = (data, removeCancel, btnText, source = "") => {
  const Data = [];

  data?.map((item, index) => {
    if (item?.Type === "Header") {
      Data.push({
        FieldType: item?.Type,
        title: item?.Value,
        level: 3,
        Icon: item?.Icon,
        Avatar: item?.Avatar,
      });
    } else if (item?.Type === "Resume") {
      const resumeFields = item?.Fields?.length ? item.Fields : [item];
      resumeFields.forEach((resumeField) => {
        Data.push({
          ...resumeField,
          FieldType: "Resume",
          fieldPosition: item?.fieldPosition,
          responsive: resumeField?.Responsive || item?.Responsive,
          rules: [
            {
              required: resumeField?.Mandatory,
              message: resumeField?.RequiredMessage || "This field is required",
            },
          ],
        });
      });
    } else if (item?.Type === "Table") {
      //Fake Commit
      const multiFieldsData = [];
      item?.Fields?.map((item, index) => {
        const fields = [];
        item?.Fields?.map((item, index) => {
          fields.push({
            ...item,
            table: true,
            rules: [
              {
                required: item?.Mandatory,
                message: item?.RequiredMessage || "This field is required",
              },
              item?.Rules ? item?.Rules : null
            ].filter(Boolean),
          });
        });
        item?.Fields;
        multiFieldsData.push({
          FieldType: item?.Type,
          Fields: fields,
        });
      });
      Data.push({
        ...item,
        FieldType: item?.Type,
        ObjectId: "table",
        Fields: multiFieldsData,
        responsive: item?.Responsive,
      });
    } else if (item?.Type === "AvatarImage") {
      Data.push({
        ...item,
        FieldType: item?.Type,
        responsive: item?.Responsive,
        rules: [
          {
            required: item?.Mandatory,
            message: item?.RequiredMessage || "This field is required",
          },
        ],
      });
    } else {
      const multiFieldsData = [];

      item?.Fields.map((item, index) => {
        multiFieldsData.push({
          ...item,
          rules: [
            {
              required: item?.Mandatory,
              message: item?.RequiredMessage || "This field is required",
            },  
            item?.Rules ? item?.Rules : null
          ].filter(Boolean),
        });
      });
      Data.push({
        FieldType: item?.Type,
        className: item?.className,
        Fields: multiFieldsData,
      });
    }
  });

  if (removeCancel) {
    if(source !== "ApplyJob")
    {   
      Data.push({
        FieldType: 3,
        title: btnText ? btnText : "Apply",
        type: "primary",
        htmlType: "submit",
        className: "mb-4",
        full: "",
        style: { width: 150, fontSize: 20, height: 50, marginTop: 20 },
        responsive: { xs: 24, sm: 24, md: 24, lg: 24, xl: 24 },
      });
    }
  } else {
    if(source !== "ApplyJob")
    {
      Data.push({
        FieldType: "ButtonsRow",
        Fields: [
          {
            FieldType: 2,
            title: "Cancel",
            type: "secondary",
            htmlType: "button",
            className: "mb-4",
            full: "",
            style: {},
            // responsive: { xs: 12, sm: 12, md: 12, lg: 12, xl: 12 },
          },
          {
            FieldType: 3,
            title: btnText || "Save & Continue",
            type: "primary",
            htmlType: "submit",
            className: "mb-4",
            full: "",
            style: {},
            // responsive: { xs: 12, sm: 12, md: 12, lg: 12, xl: 12 },
          },
        ],
      });
    }
  }

  return Data;
};
